import { useState } from "react";
import withLoader from "../../../../../../components/layouts/WithLoader";
import ListBanquesToPayement from "../../../../../../models/ListBanquesToPayement";
import getCurrentUserId from "../../../../../../reduxSaga/sagas/requests/currentUserId";
import { TextField } from "@material-ui/core";
import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import PayementRHService from "../../../../../../services/RHService/PayementRHService";
import UploadAndDownloadService from "../../../../../../services/uploadAndDownloadFile";

const PayementAvanceSalaireChequeFN = ({ startLoading, stopLoading }) => {
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [datePayementCheque, setDatePayementCheque] = useState("");
  const [codePayementCheque, setCodePayementCheque] = useState("");
  const [fileName, setFileName] = useState("");
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();
  const [infoAlertText, setInfoAlertText] = useState();
  const [file, setFile] = useState([]);

  const [amount, setAmount] = useState();

  const changeDatePayementCheque = (event) => {
    setDatePayementCheque(event.target.value.concat(":59"));
  };
  const changeAmount = (event) => {
    setAmount(event.target.value);
  };

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  const changeCodePayementCheque = (event) => {
    setCodePayementCheque(event.target.value);
  };

  const onUploadFileHandler = (e) => {
    if (e.target.files[0].size > 2097152) {
      setOpenInfoAlert(true);
      setInfoAlertText("la taille du fichier ne doit pas dépasser 2 Mo");
    } else {
      setFileName(e.target.files[0].name);

      setFile(e.target.files[0]);
    }
  };
  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };
  const payerBill = (e) => {
    if (codePayementCheque === "") {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : le code du chèque est vide ");
      // toast.error("Erreur : le champ  code chéque est vide");
    } else if (datePayementCheque === "") {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : la date d'écheance est vide ");
    } else if (amount === "") {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : le montant est vide ");
    } else if (localStorage.getItem("banqueAccount") == null) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : Merci de choisir un compte bancaire ");
    } else {


      let payementModel = {
        idUser: getCurrentUserId(),
        banqueAccountId: parseInt(localStorage.getItem("banqueAccount")),
        idEmploye: parseInt(localStorage.getItem("IdEmployeRH")),
        typePayement: 2,
        idSalary:parseInt(localStorage.getItem("IdSalary")),
        month: localStorage.getItem("monthRH"),
        year: localStorage.getItem("yearRH"),
        echanceDate: datePayementCheque,
        ammountPayed: amount,
        urlFile: "any",
        codeCheque: codePayementCheque,
        isAvanceOrTotalPayement: 0,
      };
    // console.log(JSON.stringify(payementModel))
      if (file.length !== 0) {
        const uploadData = new FormData();
        uploadData.append("picture", file);
        startLoading();
        UploadAndDownloadService.uploadFile(
          "/rh/uploadFileRH/uploadFile/Payement",
          uploadData
        )
          .then((response) => {
            if (response.data["success"]) {
              payementModel.urlFile = response.data.success;
              startLoading();
              PayementRHService.payEmployeSalaryTotalOrAvance(payementModel)
                .then((response) => {
                  console.log(response);
                  if (response.data["error"]) {
                    setOpenErrorAlert(true);
                    setErrorAlertText("Erreur :  " + response.data["error"]);
                  } else {
                    setOpenSuccessAlert(true);
                    setSuccessAlertText("Enregistrement avec succées");
                    setTimeout(() => {
                      window.location.reload();
                    }, 2000);
                  }
                })
                .catch((error) => {
                  setOpenErrorAlert(true);
                  setErrorAlertText("Erreur :  " + error);
                })
                .finally(() => {
                  stopLoading();
                });
            } else {
            }
          })
          .catch((error) => {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur :  " + error);
          })
          .finally(() => {
            stopLoading();
          });
      } else {
        startLoading();
        PayementRHService.payEmployeSalaryTotalOrAvance(payementModel)
          .then((response) => {
            console.log(response);
            if (response.data["error"]) {
              setOpenErrorAlert(true);
              setErrorAlertText("Erreur :  " + response.data["error"]);
            } else {
              setOpenSuccessAlert(true);
              setSuccessAlertText("Enregistrement avec succées");
              setTimeout(() => {
                window.location.reload();
              }, 2000);
            }
          })
          .catch((error) => {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur :  " + error);
          })
          .finally(() => {
            stopLoading();
          });
      }
    }
  };

  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };

  return (
    <>
      <div className="row">
        <div className="col-12">
          <label>Paiement par chèque / traite: </label>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <label>Montant : <span style={{color:"red"}}>Max: {localStorage.getItem("restToPay")} DNT</span> </label>
          <input
            type="number"
            min="0"
            step="0.1"
            class="form-control"
            name="amount"
            value={amount}
            onChange={changeAmount}
          />
        </div>
        <div class="col-md-4">
          <label>Code Chèque: </label>
          <input
            value={codePayementCheque}
            onChange={changeCodePayementCheque}
            class="form-control"
            placeholder="Code du chéque"
            type="number"
          />
        </div>

        <div class="col-md-4">
          <label>Date de l'échéance </label>
          <br />
          <TextField
            style={{ width: "100%" }}
            className="col-sm-12"
            variant="outlined"
            value={datePayementCheque}
            onChange={changeDatePayementCheque}
            id="datetime-local"
            type="datetime-local"
            defaultValue="date"
            InputLabelProps={{
              shrink: true,
            }}
            size="small"
          />
        </div>

        <div class="col-md-12">
          <div className="row">
            <div className="col-sm-12">
              <div class="form-group">
                <label for="exampleInputFile">Ajouter chèque </label>
                <div class="input-group">
                  <div class="custom-file">
                    <input
                      accept="application/pdf, .jpg, .jpeg, .png"
                      type="file"
                      className="custom-file-input"
                      id="exampleInputFile"
                      onChange={onUploadFileHandler}
                    />
                    <label class="custom-file-label" for="exampleInputFile">
                      {fileName}{" "}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12">
          <label>Compte bancaire </label>
          <ListBanquesToPayement type={1} />
        </div>
        <br />
        <div class="col-12">
          <button
            type="submit"
            onClick={payerBill}
            className="btn btn-dark float-right"
          >
            Payer
          </button>
        </div>
      </div>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openInfoAlert}
        autoHideDuration={4000}
        onClose={handleInfoClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleInfoClose} severity="info">
          {infoAlertText}
        </Alert>
      </Snackbar>
    </>
  );
};
export default withLoader(PayementAvanceSalaireChequeFN);
